import { Grid } from "@mui/material"

const stepStatus = {
    'Abertura': '#db5050',
    'Homologação': '#2c5fb8',
    'Execução': '#57576d',
    'Conclusão': '#3bb410',
}

export default function StepStatusList() {
    return (
        <Grid container direction="row" spacing={2} marginBottom={3}>
            {Object.keys(stepStatus).map((status) => (
                <Grid item xs={3} key={status} style={{ textAlign: 'center' }}>
                    Status: <strong style={{ color: stepStatus[status] }}>{status}</strong>
                </Grid>
            ))}
        </Grid>
    )
}